<template>
  <div id="notFoundPage">
    <div>
      <top-navbar style="position: relative;" :showHamburgerMenu="false"></top-navbar>
    </div>
    <div class="contact-us full-screen">
      <div class="skupni-box">
        <div>
          <img src="../../../static/img/StranNeObstaja/t-2-error-miss.png" class="desktop-slika">
        </div>
        <div class="leva-postavitev-box">
          <div class="leva-postavitev-vsebine">
            <div>
              <img src="../../../static/img/StranNeObstaja/t-2-error-miss.png" class="small-slika">
              <h2 class="stil-naslov">
                Ups, to pa
                <span>
                  ne bo v redu.
                </span>
              </h2>
            </div>
            <div>
              <p class="velikost-pisave">
                Stran, ki jo iščete ne obstaja ali je
                <span>
                  trenutno nedosegljiva.
                </span>
              </p>
              <p class="velikost-pisave">
                Ste se mogoče le zatipkali?
                <span>
                  Poskusite ponovno.
                </span>
              </p>
            </div>
            <div class="povezava">
              <a href="/Domov/">
                <el-button class="gumb-potrdi">
                  NAZAJ NA PRVO STRAN
                </el-button>
              </a>
            </div>
          </div>
          <div>
            <img src="../../../static/img/StranNeObstaja/t-2-error-miss-mobile.png" class="mobile-slika">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {povezave} from './../../assets/js/Povezave/povezave'
import {UserInfoAgent} from './../../assets/js/globalne_funkcije/MixinGetSap'
import TopNavbar from '../../../src/components/Dashboard/Layout/TopNavbar.vue'
import {Button} from 'element-ui'

export default {
  name: 'NotFoundPage',
  mixins: [UserInfoAgent],
  data () {
    return {}
  },
  beforeMount () {
    this.GetUserInfo()
  },
  components: {
    TopNavbar,
    [Button.name]: Button
  },
  mounted () {
    this.podpora = povezave.BASE_URL_PODPORA
  }
}
</script>

<style scoped>
#notFoundPage {
  height: 100dvh;
  background-color: black;
}

.skupni-box {
  margin: 0 auto;
  max-width: 1418px;
  margin-top: 170px;
}

.povezava {
  margin-top: 50px;
}

.leva-postavitev-vsebine {
  margin-left: 50px;
  min-height: 400px;
}

.small-slika, .mobile-slika  {
  display: none;
}

.desktop-slika {
  float: right;
  max-height: 520px;
  margin-right: 250px;
}

.stil-naslov {
  font-weight: bold;
  color: white;
  font-size: 60px;
  margin-bottom: 40px;
}

.velikost-pisave {
  font-size: 20px;
  color: white;
}

.gumb-potrdi {
  padding: 11px 38px 11px 38px !important;
}

@media screen and (max-width: 1240px) {
  .stil-naslov span {
    display: block;
  }

  .desktop-slika {
    margin-right: 40px;
  }
}

@media screen and (max-width: 1070px) {
  .gumb-potrdi {
    padding: 11px 38px 11px 38px;
  }
}

@media screen and (max-width: 900px) {
  .desktop-slika {
    display: none;
  }

  .small-slika {
    position: absolute;
    margin-left: 400px;
    width: 80px;
    display: inline-block;
    float: right;

  }
}

@media screen and (max-width: 600px) {
  .small-slika {
    display: none;
  }

  .leva-postavitev-vsebine {
    margin-left: 20px;
    text-align: left;
    max-width: 330px;
    min-height: unset;
  }

  .velikost-pisave {
    text-align: left;
    font-size: 16px;
  }

  .skupni-box {
    margin-top: 51px;
    margin: unset !important;
  }

  .stil-naslov {
    font-size: 32px;
  }

  .velikost-pisave span {
    display: block;
  }

  .mobile-slika {
    display: block;
    width: 210px;
    float: left;
    margin-top: -27px;
    margin-left: 150px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/GeneralViews/NotFoundPage.vue